import React, { useRef } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from "../common/react-redux-hooks";
import GenericButton from '../common/GenericButton';
import * as crosstabActions from '../../actions/crosstabActions';
import DynamicDataGrid from '../common/DynamicDataGrid/DynamicDataGrid';


function SharedCrossTabList(props) {
  const sharedCrosstabGrid = useRef();
  const dispatch = useDispatch();
  const {
   // uid,
    currentAccountId,
    loginResponse,
  } = useSelector(state => ({
   // uid: state.login.loginResponse.data.userId,
    currentAccountId: state.login.loginResponse.data.currentAccountId,
    loginResponse: state.login.loginResponse,
  }));

  const getSavedCrosstabColumns = () => {
    return [
      { key: 'title', name: 'Name', sortable: true },
      {
        key: 'lastModified',
        sortKey: 'lastModifiedSortable',
        name: 'Updated',
        sortable: true,
        width: 200,
        formatter: props => (
          <div>
            {props.row.title !== '' &&
          <div>
            {moment(props.row.updateDate).format('MM/D/YYYY hh:mm A')}
            {/* <button className="btn-x" onClick={() => this.deleteHandler()}>
              <img title="Delete" src={deleteIcon} alt="delete" />{' '}
            </button> */}
          </div>
      }
          </div>
        ),
      },
    ];
  };
  const handleSharedLoadCrosstab = () => {
    props.closeSharedCrossTabList();
    const sharedCrosstabGridObj = sharedCrosstabGrid.current.decoratedRef.current;
    // const data = crosstabActions.shareCrosstab(selectedItem[0].userId, props.sharedCrossTabId);
    const entry = sharedCrosstabGridObj.getSelectedEntries()[0];
    if (entry) {
     // dispatch(crosstabActions.loadSharedCrosstab(userId, entry.spcx));
      // this.props.updateCrosstabTitle(entry.title);
      const data = JSON.parse(entry.spcx);
      dispatch(crosstabActions.loadSharedCrosstab(
          loginResponse.data.uid,
          data,
        ));
    }
  };

  return (
    <div className="row">
      <div>
      <div className="row">
        {/* { props.data.length > 0 && */}
          <div className="large-12 openSharedCrossTab">
            <DynamicDataGrid
              ref={sharedCrosstabGrid}
              gridCategory="SaveCrosstabGrid"
              className="saved-crosstab-grid saved-crosstab-width"
              rows={props.data}
              columns={getSavedCrosstabColumns()}
              rowSelectionType="Single"
              isCellSelectable
              minimunRows={5}
            />
          </div>
          {/* } */}
        </div>
      </div>
      <div className="row">
          <div className="row-margin-top-10px">
            <div className="large-3 float-right text-right">
              <GenericButton
                name="Load"
                btnStyle="button load-btn"
                onBtnClick={() => handleSharedLoadCrosstab()}
              />
            </div>
          </div>
        </div>
    </div>
  );
}

SharedCrossTabList.propTypes = {
  msg: PropTypes.string,
};

export default SharedCrossTabList;
